import { Chip, IconButton, TableCell, TableRow, Typography } from '@mui/material'
import { ArrowDownload20Regular } from '@/components/Icon'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function InvoicesTableRow({ row, isLast }) {
  const chipClass =
    row.status.color === 'default' ? `${shared.chip} ${shared.chipDefault}` : shared.chip
  return (
    <TableRow
      hover
      className={`${shared.tableBodyRow}${isLast ? ` ${shared.tableBodyRowLast}` : ''}`}
    >
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.primary" className={shared.userName}>
          {row.invoiceId}
        </Typography>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.secondary">{row.billingDate}</Typography>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.primary">{row.plan}</Typography>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.primary">{row.amount}</Typography>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Chip label={row.status.label} color={row.status.color} size="small" variant="outlined" className={chipClass} />
      </TableCell>
      <TableCell align="right" className={shared.tdCellActions}>
        <IconButton size="small" aria-label={`Download invoice ${row.invoiceId}`} onClick={() => {}}>
          <ArrowDownload20Regular />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
